// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Header from "../Header/Header.bs.jsx";
import * as ReactIntl from "react-intl";
import * as RouterUtils from "../../utils/RouterUtils.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function PlaceHeader(props) {
  let createdDate = props.createdTimestamp.toDate();
  let newrecord = {...RouterUtils.createAnchorProps(undefined, "../")};
  return <Header.make
    buttonLeftSlot={<a
      {...newrecord} 
      className={Header.classes.buttonLeft}
    >
      <span>
        {"↩️"}
      </span>
      <span>
        {"Zpět"}
      </span>
    </a>}
    buttonRightSlot={props.buttonRightSlot}
    className={props.className}
    headingSlot={props.placeName}
    subheadingSlot={<ReactIntl.FormattedMessage
      id={"Place.established"}
      defaultMessage={"Založeno {time}"}
      values={{
        time: <time
          key={"time"} 
          dateTime={createdDate.toISOString()}
        >
          <ReactIntl.FormattedDate
            value={createdDate}
          />
        </time>
      }}
    />}
  />;
}

let make = PlaceHeader;

export {
  make,
}
/* Header Not a pure module */
